// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-properties-container {
    height: fit-content;
}

.skitterbook-properties-inner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--muted-blue-grey2);
    border-radius: 1rem;
    margin: 1rem;
    padding: 1rem;
}

.skitterbook-live-simulator {
    width: 100%;
    max-width: 33rem;
    aspect-ratio: 2;
}

.skitterbook-property-region {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    margin: 1rem 0rem 3rem 0rem;
}

.skitterbook-crop-image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: fit-content;
    width: auto;
}

.property-region-title {
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
}

.skitterbook-properties-title {
    margin: 1rem;
}

    .skitterbook-properties-title > span {
        font-size: 22pt;
    }
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterbookProperties.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;IAEI;QACI,eAAe;IACnB","sourcesContent":["@import '../../css//App.css';\r\n\r\n.skitterbook-properties-container {\r\n    height: fit-content;\r\n}\r\n\r\n.skitterbook-properties-inner-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    background-color: var(--muted-blue-grey2);\r\n    border-radius: 1rem;\r\n    margin: 1rem;\r\n    padding: 1rem;\r\n}\r\n\r\n.skitterbook-live-simulator {\r\n    width: 100%;\r\n    max-width: 33rem;\r\n    aspect-ratio: 2;\r\n}\r\n\r\n.skitterbook-property-region {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    align-content: center;\r\n    margin: 1rem 0rem 3rem 0rem;\r\n}\r\n\r\n.skitterbook-crop-image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: fit-content;\r\n    width: auto;\r\n}\r\n\r\n.property-region-title {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.skitterbook-properties-title {\r\n    margin: 1rem;\r\n}\r\n\r\n    .skitterbook-properties-title > span {\r\n        font-size: 22pt;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
